import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const notifications = ['María de Argentina compró este libro', 'Laura de México acaba de comprar', 'Carolina de Colombia compró este libro', 'Valentina de Chile acaba de comprar', 'Sofía de España compró este libro', 'Ana de Perú acaba de comprar', 'Camila de Uruguay compró este libro', 'Daniela de Ecuador acaba de comprar'];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    // Rotate notifications
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setIsVisible(true);
      }, 500); // Time it stays hidden before showing next
    }, 6000); // Show new notification every 6 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <div className="fixed bottom-24 md:bottom-8 left-4 z-50 pointer-events-none" data-id="element-155">
      <AnimatePresence data-id="element-156">
        {isVisible && <motion.div initial={{
        opacity: 0,
        x: -50,
        y: 20
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -50,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-center gap-4 max-w-[300px] pointer-events-auto" data-id="element-157">
            <div className="bg-brand-green/10 p-3 rounded-full relative" data-id="element-158">
              <ShoppingBag className="w-6 h-6 text-brand-green" data-id="element-159" />
              <div className="absolute top-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white animate-pulse" data-id="element-160"></div>
            </div>
            <div data-id="element-161">
              <p className="text-sm font-bold text-gray-800 leading-tight" data-id="element-162">
                {notifications[currentIndex]}
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-163">Hace unos minutos</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}